import Mappable from './mappable';
import { standardDateStamp } from '../../utils/dates';

export default class extends Mappable {
  constructor(json) {
    const { id, address, coordinates, name } = json;
    super(id, name || address, coordinates);
    this.init(json);
  }

  get mappableType() {
    return 'No Spray';
  }

  get createdAtDateStamp() {
    return standardDateStamp(this.createdAt);
  }

  get types() {
    return ['No Spray'];
  }

  get badgeSrc() {
    const { isActive, needsAction } = this;
    const activeState = isActive ? 'active' : 'inactive';
    const state = needsAction ? 'action' : activeState;
    return require(`@/assets/img/map/badge-no-spray-${state}.svg`);
  }

  get pinSrc() {
    const { isActive, needsAction } = this;
    const activeState = isActive ? 'active' : 'inactive';
    const state = needsAction ? 'action' : activeState;
    return require(`@/assets/img/map/pin-no-spray-${state}.svg`);
  }

  get siteActions() {
    const { kind } = this.requestType;
    return !!kind ? kind : 'None';
  }

  init(data) {
    const thisOriginal = {
      ...this,
    };
    Object.assign(this, data, thisOriginal);

    this.createdAt = new Date(this.createdAt);

    const computeNeedsAction = (requestType) => {
      const { kind } = requestType;
      if (!kind) {
        return false;
      }

      const actions = ['call', 'email'];

      const kindLowered = kind.toLowerCase();
      return actions.some((action) => kindLowered.includes(action));
    };
    this.needsAction = computeNeedsAction(this.requestType);
  }

  hasAnyType(types) {
    return types.includes('No Spray');
  }

  getLatestActivityDate() {
    return this.createdAt;
  }
}
